import { MDSText, MDSTextColor, MDSTextProps, MDSTextVariant, MDSTextWeight } from "@/mds";

interface EmptyTextSubtitleProps extends MDSTextProps {
  children: React.ReactNode;
}

export function EmptyTextSubtitle({ children, ...props }: EmptyTextSubtitleProps): JSX.Element {
  return (
    <MDSText
      variant={MDSTextVariant.TextXs}
      weight={MDSTextWeight.Regular}
      color={MDSTextColor.Tertiary}
      {...props}
    >
      {children}
    </MDSText>
  );
}
